import React from "react";
import { m } from "framer-motion";
import { gridContainerVariants } from "pages/playground/ProductGrid";
import { twMerge } from "tailwind-merge";

export default function LevelsList({ children, ...props }) {
  return (
    <m.ul
      {...props}
      initial="hidden"
      animate="visible"
      variants={gridContainerVariants}
      className={twMerge(
        "grid lg:grid-cols-3 gap-2 lg:gap-4 md:grid-cols-2 grid-cols-1",
        props?.className
      )}
    >
      {children}
    </m.ul>
  );
}
